import React from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Modal from 'containers/Modal/Modal';
import { ACCOUNT_SETUP_PATH } from 'constants/general';
import { showModal, clearModal } from 'actions/modals/';
import { createStorage, updateStorage } from 'actions/storages/';
import { STORAGE_LIST_MODAL, STORAGE_MODAL } from 'constants/modal';
import StorageForm from 'components/Storages/StorageForm/StorageForm';

const StorageModal = () => {
  const dispatch = useDispatch();
  const routerLocation = useLocation();
  const { pathname } = routerLocation;
  const isOnBoarding = pathname === ACCOUNT_SETUP_PATH;

  const user = useSelector(({ user }) => user);
  const modal = useSelector(({ modal }) => modal);

  const isOpen = modal?.type === STORAGE_MODAL;
  const isEditing = isOpen && modal?.initialValue;
  const modalCaption = isEditing ? 'Update Storage' : 'Create A Storage';
  const { initialValue } = modal;

  const onModalClose = () => {
    dispatch(clearModal(STORAGE_MODAL));

    if (isEditing && !isOnBoarding) {
      dispatch(showModal(STORAGE_LIST_MODAL));
    }
  };

  /**
    @param {FormData} payload
   */
  const onSubmit = (payload) => {
    const { company_id: companyId } = user;

    if (isEditing) {
      const { id: storageId } = initialValue;

      payload.append('id', storageId);

      dispatch(updateStorage(storageId, payload, companyId, false));
    } else {
      payload.append('company_id', companyId);

      dispatch(createStorage(payload, companyId));
    }

    // dispatch(clearModal(STORAGE_MODAL));
  };

  return (
    <Modal
      modalTop={10}
      modalLeft={10}
      isOpen={isOpen}
      modalWidth={80}
      onClose={onModalClose}
      caption={modalCaption}
    >
      <StorageForm
        onSubmit={onSubmit}
        initialValue={initialValue}
        onModalClose={onModalClose}
      />
    </Modal>
  );
};

export default StorageModal;
